// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__aWzwq","rightAdornment":"Header_rightAdornment__bR7rA"};